import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Query} from 'react-apollo'
import {GET_CERTIFICATE} from './mutations'
import BlockWithLoader from '../Support/BlockWithLoader'
import Form from '../People/Form'
import queryString from 'query-string'
import {CardHeader} from 'reactstrap'

import SingleCertificateTable from './helpers/SingleCertificateTable'

class Certificate extends Component {
  render() {
    const parsedQuery = queryString.parse(this.props.location.search)
    const variables = {id: this.props.match.params.id, merge_by_cert_no: parsedQuery.merge_by_cert_no === 'true'}

    return (
      <Query query={GET_CERTIFICATE} variables={variables}>
        {({data, loading, error}) => {
          if (error) return <div>An unexpected error occurred</div>

          return (
            <BlockWithLoader loading={loading} renderChildren={true}>
              <CardHeader>
                <b>Certificate id: {this.props.match.params.id}</b>
              </CardHeader>
              {!loading && <Form formShouldBeDisabled={true} editData={data.certificate.person}/>}
              <SingleCertificateTable certificate={data.certificate} dataDictionary={data.qualification_data_types}/>
            </BlockWithLoader>
          )
        }}
      </Query>
    )
  }
}

Certificate.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export default Certificate



// WEBPACK FOOTER //
// ./src/components/Welders/Certificate.js